import { render, staticRenderFns } from "./GroupsDetail.vue?vue&type=template&id=445b5c52&scoped=true&"
import script from "./GroupsDetail.vue?vue&type=script&lang=ts&"
export * from "./GroupsDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b5c52",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VForm,VTab,VTabItem,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('445b5c52')) {
      api.createRecord('445b5c52', component.options)
    } else {
      api.reload('445b5c52', component.options)
    }
    module.hot.accept("./GroupsDetail.vue?vue&type=template&id=445b5c52&scoped=true&", function () {
      api.rerender('445b5c52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/rooms/GroupsDetail.vue"
export default component.exports